export default __webpack_public_path__ + "static/media/property2.a4e75c92.png";